import { GroupId } from '../../typings/groups';
import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../typings/phrases';

import { PhrasesSelectorGeneratorAction } from './generator';

interface PhrasesSelectorBaseAction {
    groupId: GroupId;
}

export const PHRASES_SELECTOR_ADD_KEYWORDS = 'PHRASES_SELECTOR_ADD_KEYWORDS';
export type PHRASES_SELECTOR_ADD_KEYWORDS = typeof PHRASES_SELECTOR_ADD_KEYWORDS;

export interface PhrasesSelectorAddKeywordsAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_ADD_KEYWORDS;
    wizardId: PhrasesSelectorWizardId;
    phrases: Array<PhrasesSelectorPhrase>;
}

export function phrasesSelectorAddKeywords(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId,
    phrases: Array<PhrasesSelectorPhrase>
): PhrasesSelectorAddKeywordsAction {
    return {
        type: PHRASES_SELECTOR_ADD_KEYWORDS,
        groupId,
        wizardId,
        phrases
    };
}

export const PHRASES_SELECTOR_ADD_MINUS_PHRASES = 'PHRASES_SELECTOR_ADD_MINUS_PHRASES';
export type PHRASES_SELECTOR_ADD_MINUS_PHRASES = typeof PHRASES_SELECTOR_ADD_MINUS_PHRASES;

export interface PhrasesSelectorAddMinusPhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_ADD_MINUS_PHRASES;
    wizardId: PhrasesSelectorWizardId;
    phrases: Array<string>;
}

export function phrasesSelectorAddMinusPhrases(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId,
    phrases: Array<string>
): PhrasesSelectorAddMinusPhrasesAction {
    return {
        type: PHRASES_SELECTOR_ADD_MINUS_PHRASES,
        wizardId,
        groupId,
        phrases
    };
}

export const PHRASES_SELECTOR_REMOVE_KEYWORD = 'PHRASES_SELECTOR_REMOVE_KEYWORD';
export type PHRASES_SELECTOR_REMOVE_KEYWORD = typeof PHRASES_SELECTOR_REMOVE_KEYWORD;

export interface PhrasesSelectorRemoveKeywordAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_REMOVE_KEYWORD;
    index: number;
}

export function phrasesSelectorRemoveKeyword(groupId: GroupId, index: number): PhrasesSelectorRemoveKeywordAction {
    return {
        type: PHRASES_SELECTOR_REMOVE_KEYWORD,
        groupId,
        index
    };
}

export const PHRASES_SELECTOR_CLEAR_KEYWORDS = 'PHRASES_SELECTOR_CLEAR_KEYWORDS';
export type PHRASES_SELECTOR_CLEAR_KEYWORDS = typeof PHRASES_SELECTOR_CLEAR_KEYWORDS;

export interface PhrasesSelectorClearKeywordsAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CLEAR_KEYWORDS;
    wizardId: PhrasesSelectorWizardId;
}

export function phrasesSelectorClearKeywords(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorClearKeywordsAction {
    return {
        type: PHRASES_SELECTOR_CLEAR_KEYWORDS,
        wizardId,
        groupId
    };
}

export const PHRASES_SELECTOR_REMOVE_MINUS_PHRASE = 'PHRASES_SELECTOR_REMOVE_MINUS_PHRASE';
export type PHRASES_SELECTOR_REMOVE_MINUS_PHRASE = typeof PHRASES_SELECTOR_REMOVE_MINUS_PHRASE;

export interface PhrasesSelectorRemoveMinusPhraseAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_REMOVE_MINUS_PHRASE;
    wizardId: PhrasesSelectorWizardId;
    index: number;
}

export function phrasesSelectorRemoveMinusPhrase(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId,
    index: number
): PhrasesSelectorRemoveMinusPhraseAction {
    return {
        type: PHRASES_SELECTOR_REMOVE_MINUS_PHRASE,
        wizardId,
        groupId,
        index
    };
}

export const PHRASES_SELECTOR_CHANGE_MINUS_PHRASE = 'PHRASES_SELECTOR_CHANGE_MINUS_PHRASE';
export type PHRASES_SELECTOR_CHANGE_MINUS_PHRASE = typeof PHRASES_SELECTOR_CHANGE_MINUS_PHRASE;

export interface PhrasesSelectorChangeMinusPhraseAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CHANGE_MINUS_PHRASE;
    wizardId: PhrasesSelectorWizardId;
    index: number;
    phrase: string;
}

export function phrasesSelectorChangeMinusPhrase(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId,
    index: number,
    phrase: string
): PhrasesSelectorChangeMinusPhraseAction {
    return {
        type: PHRASES_SELECTOR_CHANGE_MINUS_PHRASE,
        wizardId,
        groupId,
        index,
        phrase
    };
}

export const PHRASES_SELECTOR_CLEAR_MINUS_PHRASES = 'PHRASES_SELECTOR_CLEAR_MINUS_PHRASES';
export type PHRASES_SELECTOR_CLEAR_MINUS_PHRASES = typeof PHRASES_SELECTOR_CLEAR_MINUS_PHRASES;

export interface PhrasesSelectorClearMinusPhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CLEAR_MINUS_PHRASES;
    wizardId: PhrasesSelectorWizardId;
}

export function phrasesSelectorClearMinusPhrases(
    groupId: GroupId,
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorClearMinusPhrasesAction {
    return {
        type: PHRASES_SELECTOR_CLEAR_MINUS_PHRASES,
        wizardId,
        groupId
    };
}

export const PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES = 'PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES';
export type PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES = typeof PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES;

export interface PhrasesSelectorToggleExcludePhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES;
}

export function phrasesSelectorToggleExcludePhrases(groupId: GroupId): PhrasesSelectorToggleExcludePhrasesAction {
    return {
        type: PHRASES_SELECTOR_TOGGLE_EXCLUDE_PHRASES,
        groupId
    };
}

export const PHRASES_SELECTOR_CHANGE_MANUAL_VALUE = 'PHRASES_SELECTOR_CHANGE_MANUAL_VALUE';
export type PHRASES_SELECTOR_CHANGE_MANUAL_VALUE = typeof PHRASES_SELECTOR_CHANGE_MANUAL_VALUE;

export interface PhrasesSelectorChangeManualValueAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CHANGE_MANUAL_VALUE;
    value: string;
}

export function phrasesSelectorChangeManualValue(
    groupId: GroupId,
    value: string
): PhrasesSelectorChangeManualValueAction {
    return {
        type: PHRASES_SELECTOR_CHANGE_MANUAL_VALUE,
        groupId,
        value
    };
}

export const PHRASES_SELECTOR_REFINE_KEYWORD = 'PHRASES_SELECTOR_REFINE_KEYWORD';
export type PHRASES_SELECTOR_REFINE_KEYWORD = typeof PHRASES_SELECTOR_REFINE_KEYWORD;

export interface PhrasesSelectorRefineKeywordAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_REFINE_KEYWORD;
    index: number;
    phrase: PhrasesSelectorPhrase;
}

export function phrasesSelectorRefineKeyword(
    groupId: GroupId,
    index: number,
    phrase: PhrasesSelectorPhrase
): PhrasesSelectorRefineKeywordAction {
    return {
        type: PHRASES_SELECTOR_REFINE_KEYWORD,
        groupId,
        index,
        phrase
    };
}

export const PHRASES_SELECTOR_CLEAR_DATA = 'PHRASES_SELECTOR_CLEAR_DATA';
export type PHRASES_SELECTOR_CLEAR_DATA = typeof PHRASES_SELECTOR_CLEAR_DATA;

export interface PhrasesSelectorClearDataAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CLEAR_DATA;
}

export function phrasesSelectorClearData(groupId: GroupId): PhrasesSelectorClearDataAction {
    return {
        type: PHRASES_SELECTOR_CLEAR_DATA,
        groupId
    };
}

export const PHRASES_SELECTOR_CHANGE_PRICE_RATE = 'PHRASES_SELECTOR_CHANGE_PRICE_RATE';
export type PHRASES_SELECTOR_CHANGE_PRICE_RATE = typeof PHRASES_SELECTOR_CHANGE_PRICE_RATE;

export interface PhrasesSelectorChangePriceRateAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CHANGE_PRICE_RATE;
    rate: number;
}

export function phrasesSelectorChangePriceRate(groupId: GroupId, rate: number): PhrasesSelectorChangePriceRateAction {
    return {
        type: PHRASES_SELECTOR_CHANGE_PRICE_RATE,
        groupId,
        rate
    };
}

export type PhrasesSelectorPersistentDataAction =
    | PhrasesSelectorGeneratorAction
    | PhrasesSelectorAddKeywordsAction
    | PhrasesSelectorAddMinusPhrasesAction
    | PhrasesSelectorChangeManualValueAction
    | PhrasesSelectorChangeMinusPhraseAction
    | PhrasesSelectorRefineKeywordAction
    | PhrasesSelectorRemoveKeywordAction
    | PhrasesSelectorRemoveMinusPhraseAction
    | PhrasesSelectorClearKeywordsAction
    | PhrasesSelectorClearMinusPhrasesAction
    | PhrasesSelectorToggleExcludePhrasesAction
    | PhrasesSelectorClearDataAction
    | PhrasesSelectorChangePriceRateAction;
